import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import ButtonFieldLayout from '../../layouts/common/ButtonFieldLayout';
import { useSubmitField } from '../../hooks/useSubmitField';

import { sanitizeHref } from '@wix/da-url';

import s from './OriginalsResaleField.scss';

const OriginalsResaleField = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('allowResale', {
    initAdapter: ({ adoptable }) => adoptable?.resaleAllowed ?? true,
    submitAdapter: ({ allowResale }) => ({ allow_resale: allowResale }),
  });

  return (
    <ButtonFieldLayout
      label={<InputLabelText>{t('sellerModal.create.allow_resale.label')}</InputLabelText>}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
      subLabel={t('sellerModal.create.allow_resale.sublabel', {
        postProcess: ['reactPostprocessor', 'featureBrancher'],
        learnMoreLink: (
          <PlainButtonOrLink
            className={s['link']}
            href={sanitizeHref(t('sellerModal.create.allow_resale.sublabel.link.url'))}
          >
            {t('sellerModal.create.allow_resale.sublabel.link.text')}
          </PlainButtonOrLink>
        ),
      })}
    >
      <MainToggle
        className={s['toggle']}
        variant="main"
        id={id}
        size={isMobile ? 'large' : 'small'}
        value={value}
        onChange={onChange}
        aria-labelledby={`${id}-label`}
      />
    </ButtonFieldLayout>
  );
};
OriginalsResaleField.displayName = 'OriginalsResaleField';

export default OriginalsResaleField;
